export type LocalDate = string

export function toLocalDate(date: Date): LocalDate {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}

// HH:MM, used to tell apart events held on the same day.
export function toLocalTime(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`
}
